import { Grid, Paper } from '@mui/material';
import { PoolTypography } from '@synergy/components';
import { fields } from '@synergy/utils';
import { useField } from 'formik';

import { PoolCategoryTree } from '../../../../../../common/components/pool-category-tree/pool-category-tree';
import { ProductDetailOverviewFormValues } from '../models/product-detail-overview-form-values';

export const ProductDetailOverviewSectionCategories = () => {
    const fieldNames = fields<ProductDetailOverviewFormValues>();
    const [field, _, helper] = useField<number[]>(fieldNames.categoryIds);

    return (
        <>
            <PoolTypography styleType="sectionTitle" id="app.product.detail.mapping" />
            <Grid container={true} spacing={2}>
                <Grid item={true} xs={12}>
                    <Paper elevation={0}>
                        <PoolCategoryTree
                            selectedIds={field.value}
                            onChange={helper.setValue}
                            autoSelectParents={true}
                        />
                    </Paper>
                </Grid>
            </Grid>
        </>
    );
};
